import { Routes, useLocation, Route, Outlet } from 'react-router-dom';

import DocumentList from '../documentList/index';
import StoreDocsList from '../documentList/storeDocuments';

import DocumentDetail from '../documentDetail/index';
import { DocumentProvider } from '../context/documentContext';

function DocumentRouter() {
  let { pathname } = useLocation();
  console.log(pathname,"DOCUMENT HEREEEEEEEEEEEEE")

  return (
    <DocumentProvider>
    <Routes>
       <Route path="/" element={<Outlet />}>   
       <Route index element={<DocumentList />} />      {/*  Matches `/documents` */}
       <Route path=":id" element={<DocumentDetail />} />  {/* Matches `/documents/:id` */}
       <Route path="/store" element={<StoreDocsList />} />      {/*  Matches `/documents` */}

      </Route>
    </Routes>
    </DocumentProvider>
  );
}

export default DocumentRouter;
